import PromotionEfficiencyReport from './PromotionEfficiencyReport';

export default PromotionEfficiencyReport;
